import { Box } from "@mui/material";
import IEslTemplateItem from "../../../../models/esl/eslTemplateElement";
import EslColorPalette from "../../../../components/esl/EslColorPalette";

interface ShapeElementPropretiesProps {
  selectedElement: IEslTemplateItem;
  onUpdateElement: (element: IEslTemplateItem) => void;
}

const ShapeElementPropreties = ({ selectedElement, onUpdateElement }: ShapeElementPropretiesProps) => {
  return (
    <Box sx={{
      display: "flex",
      justifyContent: "center",
    }}>
      <EslColorPalette selectedColor={selectedElement.style.backgroundColor} onColorSelect={(color) => onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, backgroundColor: color } })} />
    </Box>
  )
}

export default ShapeElementPropreties;